import { render, staticRenderFns } from "./IconPhotos.vue?vue&type=template&id=4f233c3e&scoped=true"
import script from "./IconPhotos.vue?vue&type=script&lang=js"
export * from "./IconPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f233c3e",
  null
  
)

export default component.exports